import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import _regeneratorRuntime from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/display-name */

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable react/style-prop-object */
import { useEffect, useState } from 'react';
import i18n from '../lib/translations/i18n';
import { HeadSeo } from '../components/Seo';
import { ScrollToTopButton } from '@yalendar/shared/ui-core';
import { useTranslation } from 'react-i18next';
import { Directus } from '@directus/sdk';
import HomeNavbar from '../components/HomePage/Navbar';
import TrustBox from '../components/HomePage/TrustBox';
import DetailsSection from '../components/HomePage/DetailsSection';
import UltimateFearures from '../components/HomePage/UltimateFearures';
import Pricing from '../components/HomePage/Pricing';
import FAQ from '../components/HomePage/FAQ';
import Footer from '../components/HomePage/Footer';
import TabSetup from '../components/HomePage/Tab';
var footerNavigation = {
  solutions: [{
    name: 'landing.footerNavigation.solutions.marketing',
    href: '#'
  }, {
    name: 'landing.footerNavigation.solutions.analytics',
    href: '#'
  }, {
    name: 'landing.footerNavigation.solutions.commerce',
    href: '#'
  }, {
    name: 'landing.footerNavigation.solutions.insights',
    href: '#'
  }],
  support: [// { name: i18n.t('landing.footerNavigation.support.pricing'), href: '#' },
  {
    name: 'landing.footerNavigation.support.documentation',
    href: 'https://docs.yalendar.com'
  }, {
    name: 'landing.footerNavigation.company.blog',
    href: '/blog'
  }, {
    name: 'landing.footerNavigation.support.guides',
    href: '#'
  }, {
    name: 'landing.footerNavigation.support.api',
    href: 'https://api.yalendar.com/api/'
  }],
  company: [{
    name: 'landing.footerNavigation.company.about',
    href: '#'
  }, {
    name: 'landing.footerNavigation.company.blog',
    href: '/blog'
  }, {
    name: 'landing.footerNavigation.company.jobs',
    href: '#'
  }, {
    name: 'landing.footerNavigation.company.press',
    href: '#'
  }, {
    name: 'landing.footerNavigation.company.partners',
    href: '#'
  }],
  legal: [//{ name: i18n.t('landing.footerNavigation.legal.claim'), href: '#' },
  {
    name: 'landing.footerNavigation.legal.privacy',
    href: '/privacy-policy'
  }, {
    name: 'landing.footerNavigation.legal.terms',
    href: '/terms-and-conditions'
  }],
  social: [{
    name: 'Facebook',
    href: 'https://www.facebook.com/YalendarApp',
    icon: function icon(props) {
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
        fill: "currentColor",
        viewBox: "0 0 24 24"
      }, props), {}, {
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
          clipRule: "evenodd"
        })
      }));
    }
  }, {
    name: 'Instagram',
    href: 'https://www.instagram.com/YalendarApp/',
    icon: function icon(props) {
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
        fill: "currentColor",
        viewBox: "0 0 24 24"
      }, props), {}, {
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          d: "M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z",
          clipRule: "evenodd"
        })
      }));
    }
  }, {
    name: 'Twitter',
    href: 'https://twitter.com/Yalendar_App',
    icon: function icon(props) {
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
        fill: "currentColor",
        viewBox: "0 0 24 24"
      }, props), {}, {
        children: /*#__PURE__*/_jsx("path", {
          d: "M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
        })
      }));
    }
  }, {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/yalendar/',
    icon: function icon(props) {
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
        fill: "currentColor",
        viewBox: "0 0 64 64"
      }, props), {}, {
        children: /*#__PURE__*/_jsx("path", {
          d: "M49.837,48.137V36.425c0-6.275-3.35-9.195-7.816-9.195  c-3.604,0-5.219,1.983-6.119,3.374V27.71h-6.79c0.09,1.917,0,20.427,0,20.427h6.79V36.729c0-0.609,0.044-1.219,0.224-1.655  c0.49-1.22,1.607-2.483,3.482-2.483c2.458,0,3.44,1.873,3.44,4.618v10.929H49.837z M21.959,24.922c2.367,0,3.842-1.57,3.842-3.531  c-0.044-2.003-1.475-3.528-3.797-3.528s-3.841,1.524-3.841,3.528c0,1.961,1.474,3.531,3.753,3.531H21.959z M33,64  C16.432,64,3,50.568,3,34C3,17.431,16.432,4,33,4s30,13.431,30,30C63,50.568,49.568,64,33,64z M25.354,48.137V27.71h-6.789v20.427  H25.354z"
        })
      }));
    }
  }, {
    name: 'GitHub',
    href: 'https://github.com/kreezus',
    icon: function icon(props) {
      return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
        fill: "currentColor",
        viewBox: "0 0 24 24"
      }, props), {}, {
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          d: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
          clipRule: "evenodd"
        })
      }));
    }
  }]
};
export function Index(_ref) {
  var browserConfigProps = _ref.browserConfigProps;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState([]),
      faqs = _useState[0],
      setFaqs = _useState[1];

  var _useState2 = useState([]),
      freePlan = _useState2[0],
      setFreePlan = _useState2[1];

  var _useState3 = useState([]),
      proPlan = _useState3[0],
      setProPlan = _useState3[1];

  var loadFaqs = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _faqsDirectusResponse;

      var directus, faqsDirectusResponse, computedFaqs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              directus = new Directus('https://cms.kreezus.tech');
              _context.next = 3;
              return directus.items('yalendar_faq_translations').readMany({
                meta: 'total_count'
              });

            case 3:
              faqsDirectusResponse = _context.sent;
              computedFaqs = (_faqsDirectusResponse = faqsDirectusResponse.data) === null || _faqsDirectusResponse === void 0 ? void 0 : _faqsDirectusResponse.filter(function (faq) {
                var _faq$languages_id;

                return (_faq$languages_id = faq.languages_id) === null || _faq$languages_id === void 0 ? void 0 : _faq$languages_id.startsWith((i18n === null || i18n === void 0 ? void 0 : i18n.language) || '');
              }).map(function (faq) {
                return {
                  question: faq.question || '',
                  answer: faq.answer || ''
                };
              });
              setFaqs(computedFaqs || []);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadFaqs() {
      return _ref2.apply(this, arguments);
    };
  }();

  var loadFreePlanFeatures = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _pricingDirectusRespo;

      var directus, pricingDirectusResponse, computedFreePlan;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              directus = new Directus('https://cms.kreezus.tech');
              _context2.next = 3;
              return directus.items('free_plan_translations').readMany({
                meta: 'total_count'
              });

            case 3:
              pricingDirectusResponse = _context2.sent;
              computedFreePlan = (_pricingDirectusRespo = pricingDirectusResponse.data) === null || _pricingDirectusRespo === void 0 ? void 0 : _pricingDirectusRespo.filter(function (freePlan) {
                var _freePlan$languages_c;

                return (_freePlan$languages_c = freePlan.languages_code) === null || _freePlan$languages_c === void 0 ? void 0 : _freePlan$languages_c.startsWith((i18n === null || i18n === void 0 ? void 0 : i18n.language) || '');
              }).map(function (freePlan) {
                return {
                  forfait: freePlan.forfait || ''
                };
              });
              setFreePlan(computedFreePlan || []);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function loadFreePlanFeatures() {
      return _ref3.apply(this, arguments);
    };
  }();

  var loadProPlanFeatures = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _pricingDirectusRespo2;

      var directus, pricingDirectusResponse, computedProPlan;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              directus = new Directus('https://cms.kreezus.tech');
              _context3.next = 3;
              return directus.items('pro_monthly_plan_translations').readMany({
                meta: 'total_count'
              });

            case 3:
              pricingDirectusResponse = _context3.sent;
              computedProPlan = (_pricingDirectusRespo2 = pricingDirectusResponse.data) === null || _pricingDirectusRespo2 === void 0 ? void 0 : _pricingDirectusRespo2.filter(function (ProPlan) {
                var _ProPlan$languages_co;

                return (_ProPlan$languages_co = ProPlan.languages_code) === null || _ProPlan$languages_co === void 0 ? void 0 : _ProPlan$languages_co.startsWith((i18n === null || i18n === void 0 ? void 0 : i18n.language) || '');
              }).map(function (ProPlan) {
                return {
                  forfait: ProPlan.forfait || ''
                };
              });
              setProPlan(computedProPlan || []);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function loadProPlanFeatures() {
      return _ref4.apply(this, arguments);
    };
  }();

  useEffect(function () {
    loadFaqs();
    loadFreePlanFeatures();
    loadProPlanFeatures();
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HeadSeo, {
      siteName: 'Yalendar.com',
      title: "".concat(t('landing.easySchedulingAndOnlineMeeting')),
      url: 'https://yalendar.com/',
      description: t('landing.welcomeDescription')
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative overflow-hidden bg-white",
      children: [/*#__PURE__*/_jsx(HomeNavbar, {
        appURL: browserConfigProps.appURL
      }), /*#__PURE__*/_jsx(TrustBox, {}), /*#__PURE__*/_jsx(DetailsSection, {}), /*#__PURE__*/_jsx(TabSetup, {}), /*#__PURE__*/_jsx(UltimateFearures, {}), /*#__PURE__*/_jsx(Pricing, {
        freePlan: freePlan,
        premiumPlan: proPlan,
        apiUrl: browserConfigProps.appURL
      }), /*#__PURE__*/_jsx(FAQ, {
        faqs: faqs
      }), /*#__PURE__*/_jsx(Footer, {
        footerNavigation: footerNavigation
      })]
    }), /*#__PURE__*/_jsx(ScrollToTopButton, {})]
  });
}
export default Index;